<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ isEditing ? 'Ansprechpartnerin bearbeiten' : 'Neue Ansprechpartnerin' }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="contactPersonForm">

          <v-text-field
            v-model="formData.name"
            label="Name*"
            required
          ></v-text-field>

          <v-text-field
            v-model="formData.position"
            label="Position"
          ></v-text-field>

          <v-text-field
            v-model="formData.email"
            label="Email"
            type="email"
          ></v-text-field>

          <v-text-field
            v-model="formData.phone"
            label="Telefon"
            @input="formatPhoneInput"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Abbrechen</v-btn>
        <v-btn v-if="isEditing" color="error" @click="deleteContact">Löschen</v-btn>
        <v-btn color="primary" @click="save">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ContactPersonDialog',

  props: {
    value: Boolean,
    contact: Object,
    customer: Object
  },

  data() {
    return {
      formData: {
        name: '',
        position: '',
        email: '',
        phone: ''
      }
    }
  },

  computed: {
    isEditing() {
      return !!this.contact
    }
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.loadContactData()
      }
    },
    
    contact(newVal) {
      if (newVal && this.value) {
        this.loadContactData()
      }
    }
  },

  methods: {
    loadContactData() {
      if (this.contact) {
        this.formData = { ...this.contact }
      } else {
        this.formData = {
          name: '',
          position: '',
          email: '',
          phone: ''
        }
      }
    },

    formatPhoneInput() {
      if (this.formData.phone) {
        this.formData.phone = this.formData.phone.replace(/[^\d+]/g, '')
      }
    },

    close() {
      this.$emit('input', false)
    },

    save() {
      if (!this.formData.name) {
        alert('Please enter a name for the contact person')
        return
      }

      const contactData = {
        ...this.formData,
        customer_id: this.customer.id
      }

      if (this.isEditing) {
        contactData.id = this.contact.id
        contactData.updated_at = new Date().toISOString()
      } else {
        contactData.created_at = new Date().toISOString()
        contactData.updated_at = new Date().toISOString()
      }

      this.$emit('save', contactData)
    },

    deleteContact() {
      if (!confirm('Are you sure you want to delete this contact person?')) {
        return
      }
      this.$emit('delete')
    }
  }
}
</script>